<template>
  <NxSelectReduced
    :value="localValue"
    :options="listOptions"
    labelText="Tipos de Pessoa:"
    id="selectTipoPessoa"
    placeholder="Selecione o tipo de pessoa"
    :multiple="false"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxSelectReduced>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectTipoPessoa',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listOptions: [
        { value: 'PF', text: 'Pessoa Física' },
        { value: 'PJ', text: 'Pessoa Jurídica' }
      ],
      selected: null
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectTipoPessoa.vue